/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var callIf = function callIf(conditionalFn, callBack) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return Promise.resolve(conditionalFn.apply(void 0, args)).then(function (condition) {
      return condition && callBack.apply(void 0, args);
    });
  };
};
var callIf$1 = callIf;

export { callIf$1 as default };
